// removed by extract-text-webpack-plugin
module.exports = {"Header":"src-components-Header----header-module---Header---10RMb","Items":"src-components-Header----header-module---Items---1fEP9","Icons":"src-components-Header----header-module---Icons---1A3Rr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/header.module.css
// module id = 35
// module chunks = 77196258398326 114276838955818 155911550660936 192279678295350